import moment from "moment";
import React from "react";
import { forwardRef } from "react";
const MFFundHoldingReportTable = forwardRef(
  (
    {
      tableData,
      handleTableScroll,
      hasVerticalScroll,
      scrollLoaderTable,
      loader,
      LoaderForSearch,
      clientDashboard,
    },
    ref
  ) => {
    return (
      <table className="table" style={{ width: "570%" }}>
        <thead>
          <tr>
            <th className={clientDashboard ? "text-center" : ""}>
              <span className="wrap-th">
                <span>Sr No.</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>User ID</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>PAN</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>Folio ID</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>Scheme Investment Type</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>Investment Type</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>Scheme Name</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>ISIN</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>Current Value</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>Invested Value</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>Returns</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>Absolute Returns</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>CAGR</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>NAV</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>Units</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>Dividend</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>One Day Change</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>One Day Change Per</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>Folio Number</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>BSE Order Number</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>Amount</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>Next Instalment Date</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>Avg. NAV</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>Current NAV Date</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>Distributor</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>Scheme Code</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>SIP Status</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>Investment Amount</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>Flag</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>Mandate Token ID</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>SIP Dates</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>AMC Code</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>Category</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>Main Category</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>Min SIP Amt.</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>Max SIP Amt.</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>Min Purchase Amt.</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>Max Purchase Amt.</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>Purchase Date</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>XIRR</span>
              </span>
            </th>
            <th>
              <span className="wrap-th">
                <span>Unrealised PNL</span>
              </span>
            </th>
            {hasVerticalScroll && <th className="scrollerthead"></th>}
          </tr>
        </thead>
        <tbody
          onScroll={(e) => handleTableScroll(e)}
          id="per-table-body"
          ref={ref}
        >
          {tableData?.length > 0 &&
            tableData.map((item, index) => {
              return (
                <tr key={index}>
                  <td className={clientDashboard ? "text-center" : ""}>
                    {index + 1}
                  </td>
                  <td>{item?.userId}</td>
                  <td>{item?.pan || "-"}</td>
                  <td>{item?.folioId || "-"}</td>
                  <td>{item?.schInvType || "-"}</td>
                  <td>{item?.invType || "-"}</td>
                  <td>{item?.schName || "-"}</td>
                  <td>{item?.isin || "-"}</td>
                  <td>{item?.currVal || "-"}</td>
                  <td>{item?.invAmt || "-"}</td>
                  <td>{item?.returns || "-"}</td>
                  <td>{item?.absRet || "-"}</td>
                  <td>{item?.cagr || "-"}</td>
                  <td>{item?.nav || "-"}</td>
                  <td>{item?.units || "-"}</td>
                  <td>{item?.dividend || "-"}</td>
                  <td>{item?.oneDayChg || "-"}</td>
                  <td>{item?.oneDayChgPer || "-"}</td>
                  <td>{item?.folioNo || "-"}</td>
                  <td>{item?.bseOrderNo || "-"}</td>
                  <td>{item?.amt || "-"}</td>
                  <td>
                    {item?.nxtInstDt
                      ? moment(item?.nxtInstDt).format("DD-MM-YYYY")
                      : "-"}
                  </td>
                  <td>{item?.avgNav || "-"}</td>
                  <td>
                    {item?.currNavDt
                      ? moment(item?.currNavDt).format("DD-MM-YYYY")
                      : "-"}
                  </td>
                  <td>{item?.distributor || "-"}</td>
                  <td>{item?.bseSchCode || "-"}</td>
                  <td>{item?.sipStatus || "-"}</td>
                  <td>{item?.instAmt || "-"}</td>
                  <td>{item?.sipFlag || "-"}</td>
                  <td>{item?.mandateId || "-"}</td>
                  <td>{item?.sipDates || "-"}</td>
                  <td>{item?.amcCode || "-"}</td>
                  <td>{item?.category || "-"}</td>
                  <td>{item?.mainCategory || "-"}</td>
                  <td>{item?.minSIPAmt || "-"}</td>
                  <td>{item?.maxSIPAmt || "-"}</td>
                  <td>{item?.minPurchAmt || "-"}</td>
                  <td>{item?.maxPurchAmt || "-"}</td>
                  <td>
                    {item?.purchDt
                      ? moment(item?.purchDt).format("DD-MM-YYYY")
                      : "-"}
                  </td>
                  <td>{item?.xirr || "-"}</td>
                  <td>{item?.unrealisedPNL || "-"}</td>
                </tr>
              );
            })}
          {scrollLoaderTable && !loader && (
            <div className="loader-center">
              <LoaderForSearch />
            </div>
          )}
        </tbody>
      </table>
    );
  }
);

export default MFFundHoldingReportTable;
